import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

export interface ICardSectionNewProps {
  id?: string;
  hideForPrint?: boolean;
  withBorders?: boolean;
  withBorder?: boolean;
  withTopBorder?: boolean;
  withBottomBorder?: boolean;
  children: React.ReactNode;
}

export const CardSectionNew: React.FC<ICardSectionNewProps> = ({
  id,
  withBorder,
  withTopBorder,
  withBottomBorder,
  withBorders,
  hideForPrint,
  children,
}) => {
  return (
    <div className={cn(styles['section'], hideForPrint && styles['hide-for-print'])} id={id}>
      <div
        className={cn(
          styles['item'],
          withBorder && styles['with-border'],
          withTopBorder && styles['with-border'],
          withBottomBorder && styles['with-bottom-border'],
        )}
      >
        <div className={cn(styles['inner'], withBorders && styles['with-borders'])}>{children}</div>
      </div>
    </div>
  );
};
